<template>
  <Dialog
    :visible="!!authErrorMessage"
    modal
    :draggable="false"
    :showHeader="false"
    dismissableMask
    class="w-11/12 max-w-[23rem]"
    :pt="{ content: { class: '!p-0' }, root: { class: '!rounded-[28px] overflow-hidden !border-0 !shadow-2xl' }, mask: { class: '!bg-black/50' } }"
    @update:visible="v => { if (!v) clearAuthError(); }"
  >
    <div class="relative flex flex-col items-center text-center bg-white px-6 pt-9 pb-6 gap-4">
      <button
        type="button"
        class="absolute top-3.5 left-3.5 w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
        aria-label="סגירה"
        @click="clearAuthError"
      >
        <i class="pi pi-times text-sm" />
      </button>

      <div class="w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center">
        <i class="pi pi-lock text-[26px] text-amber-500" />
      </div>

      <p class="text-[15.5px] font-medium leading-relaxed text-gray-800 whitespace-pre-line max-w-[18rem]">
        {{ authErrorMessage }}
      </p>

      <Button label="הבנתי" class="w-full !rounded-2xl !py-2.5 mt-1" @click="clearAuthError" />
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { useAuthError } from '@app/composables/auth-error';

const { authErrorMessage, clearAuthError } = useAuthError();
</script>
